import React, { useEffect, useRef, useState } from 'react';
import * as signalR from '@microsoft/signalr';
import { useHistory, useLocation } from 'react-router-dom';
import { Card, Form, Container, Table, Badge as BsBadge, Button, Tooltip, OverlayTrigger, Modal, Nav, Tab } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import Pagination from 'react-js-pagination';
import * as moment from 'moment';
import { BaseGatewayImage, DOITUONG_API, HOADON_API, HOSO_TUYENSINH_API, LICHSUTHANHTOAN_API, QRGENERATOR_API, LYLICHKHOAHOC_API, DECUONGNGHIENCUU_API, VANBANGTUYENSINH_API, VANBANGDAIHOC_API, CHUYENNGANH_API } from '@app/utils/apiUrl';
import { Get, DeleteSingle, Put, Post } from '@app/utils/httpProvider';
import { toast } from 'react-toastify';
import { createUrlWithParam } from '../../../../../utils/helper';
import { URI_INTERNAL } from '../../../../../utils/pathLocations';
import { userManager } from '@app/utils/oidc';
import {
    trangThaiHoSoDuTuyenValue,
    objectTrangThaiHoSoDuTuyen,
    objectShowNumber,
    invoiceStatusValues,
    loaiTuyenSinhValue,
} from '../../../../../utils/define';
import HoSoTuyenSinhDetailModal from './HoSoTuyenSinhDetailModal';
import DangKyHoSoModal from './DangKyHoSoModal';
import DangKyHoSoLopDaoTaoModal from './DangKyHoSoLopDaoTaoModal';
import { ConfirmModal } from '../../../../../modules/modal/ConfirmModal';
import DocumentInput from '../../../../../components/document-input/DocumentInput';
import XuatHoaDonModal from './XuatHoaDonModal';
// import qrImage from '../../../../../assets/QRnhantien.jpg';
import { QRCodeSVG } from 'qrcode.react';

const QR_VALIDITY_SECONDS = 2 * 60;

const normalizeInvoiceStatus = (value) => {
    if (typeof value === 'number') return value;
    if (typeof value !== 'string') return value;

    const normalizedValue = value.trim();
    if (Object.prototype.hasOwnProperty.call(invoiceStatusValues, normalizedValue)) {
        return invoiceStatusValues[normalizedValue];
    }

    const numericValue = Number(normalizedValue);
    return Number.isNaN(numericValue) ? normalizedValue : numericValue;
};

const getInvoicesFromPaymentHistory = (paymentHistory) => {
    const invoiceCollection = paymentHistory?.hoaDonThanhToans
        ?? paymentHistory?.HoaDonThanhToans
        ?? [];

    return Array.isArray(invoiceCollection)
        ? invoiceCollection
        : invoiceCollection?.$values ?? [];
};

const base64ToPdfUrl = (base64Data) => {
    const normalizedBase64 = base64Data.includes(',')
        ? base64Data.substring(base64Data.indexOf(',') + 1)
        : base64Data;
    const binary = window.atob(normalizedBase64.replace(/\s/g, ''));
    const bytes = new Uint8Array(binary.length);

    for (let index = 0; index < binary.length; index += 1) {
        bytes[index] = binary.charCodeAt(index);
    }

    return URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }));
};

const InvoicePreviewButton = ({ applicationCode, dotThanhToan }) => {
    const paymentCode = `${applicationCode}${applicationCode[2] !== '1' ? dotThanhToan : ''}`;
    const { data: paymentHistoryResponse } = useQuery(
        ['paymentHistoryForInvoicePreview', paymentCode],
        () => Get(LICHSUTHANHTOAN_API.GET_ITEM_BY_CUSTCODE, paymentCode),
        { enabled: !!applicationCode, staleTime: 30000 }
    );
    const paymentHistory = paymentHistoryResponse?.data ?? paymentHistoryResponse;
    const invoice = getInvoicesFromPaymentHistory(paymentHistory)
        .find((item) => item?.erpid ?? item?.ERPID);
    const erpId = invoice?.erpid ?? invoice?.ERPID;

    const previewMutation = useMutation(async () => {
        const response = await Post(HOADON_API.XEM_HOA_DON, null, { ERPID: erpId }, false);
        const responseData = await response.json();
        const results = responseData?.$values ?? responseData;
        const result = Array.isArray(results) ? results[0] : results;
        const previewError = result?.errors ?? result?.Errors;

        if (previewError) throw new Error(previewError);

        const pdfData = result?.data ?? result?.Data;
        if (!pdfData) throw new Error('API không trả về dữ liệu PDF của hóa đơn');

        return base64ToPdfUrl(pdfData);
    });

    if (!erpId) return null;

    const previewInvoice = () => {
        const previewWindow = window.open('', '_blank');
        if (!previewWindow) {
            toast.error('Trình duyệt đang chặn cửa sổ xem hóa đơn');
            return;
        }

        previewWindow.document.title = 'Đang tải hóa đơn...';
        previewWindow.document.body.textContent = 'Đang tải hóa đơn...';
        previewMutation.mutate(undefined, {
            onSuccess: (pdfUrl) => {
                previewWindow.location.replace(pdfUrl);
                window.setTimeout(() => URL.revokeObjectURL(pdfUrl), 60000);
            },
            onError: (error) => {
                previewWindow.close();
                toast.error(error?.message || 'Không thể xem hóa đơn');
            }
        });
    };

    return (
        <Button
            onClick={previewInvoice}
            disabled={previewMutation.isLoading}
            className="mt-2 px-4 py-2 d-flex align-items-center justify-content-center border-0 shadow-sm"
            style={{ backgroundColor: '#0ea5e9', borderRadius: '8px', color: '#ffffff', fontSize: '1rem', fontWeight: '500' }}
        >
            <i className="fas fa-print mr-2" style={{ fontSize: '1.1rem' }}></i>
            {previewMutation.isLoading ? 'Đang tải hóa đơn...' : 'Xem hóa đơn'}
        </Button>
    );
};

const HoSoTuyenSinh = () => {
    const history = useHistory();
    const location = useLocation();
    const valueSearch = useSelector((state) => state.search.valueSearch);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(1000);
    const [search, setSearch] = useState('');
    const [accountId, setAccountId] = useState('');
    const [activeTab, setActiveTab] = useState('0');
    const queryClient = useQueryClient();
    const [selectedRow, setSelectedRow] = useState(null);

    // Modal states
    const [showDetail, setShowDetail] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [selectedHoSoId, setSelectedHoSoId] = useState(null);
    const [selectedDotTuyenSinhId, setSelectedDotTuyenSinhId] = useState(null);

    // Delete Confirm Modal states
    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState('');
    const [openConfirmSubmitModal, setOpenConfirmSubmitModal] = useState(false);
    const [appToSubmit, setAppToSubmit] = useState(null);
    const [confirmDelMessage, setConfirmDelMessage] = useState('');

    // QR Modal state
    const [showQRModal, setShowQRModal] = useState(false);
    const [fileMinhChungLePhi, setFileMinhChungLePhi] = useState('');
    const [qrCodeValue, setQrCodeValue] = useState('');
    const [qrAmount, setQrAmount] = useState(0);
    const [soHoSo, setSoHoSo] = useState('');
    const [maThanhToan, setMaThanhToan] = useState('');
    const [ghiChu, setGhiChu] = useState('');
    const [isGeneratingQR, setIsGeneratingQR] = useState(false);
    const [qrSecondsRemaining, setQrSecondsRemaining] = useState(0);
    const [qrRequestModel, setQrRequestModel] = useState(null);
    const transactionHubRef = useRef(null);
    const currentPaymentCodeRef = useRef('');
    const currentPaymentInvoiceRef = useRef(null);

    const [xuatHoaDonData, setXuatHoaDonData] = useState(null);
    const [paymentError, setPaymentError] = useState('');
    const [currentTime, setCurrentTime] = useState(() => moment());

    const invoiceActionCutoff = moment(currentTime).hour(23).minute(45).second(0).millisecond(0);
    const canShowInvoiceActions = currentTime.isBefore(invoiceActionCutoff);

    const itemAccount = useSelector((state) => state.account.itemAccount);

    const { data: doiTuongData } = useQuery(
        ['doiTuongDataHoSoTuyenSinh'],
        () => Get(DOITUONG_API.GET_PAGING, null, { PageIndex: 1, PageSize: 1000 }),
        { keepPreviousData: true }
    );
    const listDoiTuong = doiTuongData?.data?.$values || doiTuongData?.data || [];

    useEffect(() => {
        const fetchInfo = async () => {
            const user = await userManager.getUser();
            const accId = user?.profile?.sub || null;
            if (accId) setAccountId(accId);
        };
        fetchInfo();
    }, []);

    useEffect(() => {
        const timer = window.setInterval(() => setCurrentTime(moment()), 30000);
        return () => window.clearInterval(timer);
    }, []);

    const paramUrl = new URLSearchParams(location.search.substring(1));
    if (paramUrl.get('page') != null && parseInt(paramUrl.get('page'), 10) !== page) {
        setPage(parseInt(paramUrl.get('page'), 10));
    }
    if (paramUrl.get('size') != null && parseInt(paramUrl.get('size'), 10) !== pageSize) {
        setPageSize(parseInt(paramUrl.get('size'), 10));
    }
    if (paramUrl.get('search') != null && paramUrl.get('search') !== search) {
        setSearch(paramUrl.get('search'));
    }

    const replaceHistory = (Page, Size, Search) => {
        history.replace(
            createUrlWithParam(URI_INTERNAL.HOSOTUYENSINH_PATH, {
                page: Page,
                size: Size,
                search: Search
            })
        );
    };

    const { isLoading, isError, error, data, refetch } = useQuery(
        ['myApplications', accountId, valueSearch, page, pageSize, activeTab],
        () => {
            const model = {
                Keyword: valueSearch || '',
                PageIndex: page,
                PageSize: pageSize,
                AccountId: accountId,
                LoaiTuyenSinh: Number(activeTab)
            };
            replaceHistory(page, pageSize, valueSearch);
            return Get(HOSO_TUYENSINH_API.GET_PAGING, null, model);
        },
        {
            enabled: !!accountId,
            keepPreviousData: true
        }
    );

    useEffect(() => {
        if (!accountId) return undefined;

        let disposed = false;
        const connection = new signalR.HubConnectionBuilder()
            .withUrl(`${BaseGatewayImage}/hubs/transactions`, {
                accessTokenFactory: async () => {
                    const user = await userManager.getUser();
                    return user?.access_token || '';
                }
            })
            .withAutomaticReconnect()
            .configureLogging(signalR.LogLevel.Warning)
            .build();

        const handleTransaction = (notification, failed = false) => {
            if (disposed) return;

            const currentPaymentCode = currentPaymentCodeRef.current;
            const customerCode = notification?.customerCode ?? notification?.CustomerCode ?? '';

            if (!currentPaymentCode || typeof customerCode !== 'string' || !customerCode.endsWith(currentPaymentCode)) return;

            currentPaymentCodeRef.current = '';
            setShowQRModal(false);
            setQrCodeValue('');
            setQrSecondsRemaining(0);
            setQrRequestModel(null);
            const message = notification?.message || notification?.Message || '';

            // TransactionFailed được gửi sau rollback, không mở form hóa đơn.
            if (failed) {
                const transactionId = notification?.transactionId ?? notification?.TransactionId;
                setPaymentError(message || `${transactionId ? `Mã giao dịch: ${transactionId} - ` : ''}Không thể ghi nhận thanh toán hoặc tạo phiếu thu. Vui lòng liên hệ bộ phận hỗ trợ để kiểm tra giao dịch; không thanh toán lại.`);
                setXuatHoaDonData(null);
                currentPaymentInvoiceRef.current = null;
                refetch();
                return;
            }

            // TransactionPaid xác nhận lịch sử thanh toán và phiếu thu đã được commit.
            setPaymentError('');
            queryClient.invalidateQueries(['paymentHistoryForInvoicePreview', currentPaymentCode]);
            queryClient.invalidateQueries(['xuatHoaDonData', currentPaymentCode]);
            setXuatHoaDonData({
                ...currentPaymentInvoiceRef.current,
                mode: 'edit',
                notification: { ...notification, message }
            });
            currentPaymentInvoiceRef.current = null;
            refetch();
        };

        connection.on('TransactionPaid', (notification) => handleTransaction(notification));
        connection.on('TransactionFailed', (notification) => handleTransaction(notification, true));

        connection.start()
            .then(() => {
                if (disposed) {
                    connection.stop();
                    return;
                }
                transactionHubRef.current = connection;
            })
            .catch((hubError) => {
                if (!disposed) {
                    console.error('SignalR connection failed', {
                        url: `${BaseGatewayImage}/hubs/transactions`,
                        statusCode: hubError?.statusCode,
                        message: hubError?.message,
                        error: hubError
                    });
                }
            });

        return () => {
            disposed = true;
            currentPaymentCodeRef.current = '';
            currentPaymentInvoiceRef.current = null;
            connection.off('TransactionPaid');
            connection.off('TransactionFailed');
            if (transactionHubRef.current === connection) transactionHubRef.current = null;
            connection.stop().catch(() => {});
        };
    }, [accountId, refetch, queryClient]);

    useEffect(() => {
        if (accountId) {
            refetch();
        }
    }, [pageSize, page, accountId, activeTab]);

    useEffect(() => {
        if (valueSearch != null && valueSearch !== search && accountId) {
            setPage(1);
            replaceHistory(1, pageSize, valueSearch);
        }
    }, [valueSearch, accountId]);

    const changePage = (number) => {
        setPage(number);
        replaceHistory(number, pageSize, search);
    };

    const onChangeShowNumber = (e) => {
        setPageSize(Number(e.target.value));
        replaceHistory(page, Number(e.target.value), search);
    };

    const handleSelectTab = (k) => {
        setActiveTab(k);
        setPage(1);
    };

    const items = data?.data?.$values ? data.data.$values : data?.data || [];
    const totalRecords = data?.totalRecords || 0;

    useEffect(() => {
        if (items && items.length > 0) {
            setSelectedRow(prev => {
                if (prev) {
                    const fresh = items.find(item => (item.id || item.Id) === (prev.id || prev.Id));
                    return fresh || items[0];
                }
                return items[0];
            });
        } else {
            setSelectedRow(null);
        }
    }, [data, activeTab]);

    const getLabelFromEnum = (value, objectEnum, valueMap) => {
        if (value === null || value === undefined) return '';
        const actualValue = typeof value === 'string' && valueMap ? valueMap[value] : value;
        const found = objectEnum.find((item) => item.value === actualValue);
        return found ? found.label : '';
    };

    const handleViewDetail = (app) => {
        setSelectedHoSoId(app.id || app.Id);
        setShowDetail(true);
    };

    const handleEdit = (app) => {
        setSelectedHoSoId(app.id || app.Id);
        setSelectedDotTuyenSinhId(app.dotTuyenSinhId || app.DotTuyenSinhId);
        setShowEdit(true);
    };

    const handleDelete = (app) => {
        setIdWantDelete(app.id || app.Id);
        setConfirmDelMessage(app.soHoSo || app.SoHoSo || 'hồ sơ này');
        setOpenConfirmDeleteModal(true);
    };

    const acceptDelete = async () => {
        if (!idWantDelete) return;
        try {
            const res = await DeleteSingle(HOSO_TUYENSINH_API.DELETE_ITEM, idWantDelete);
            if (res && res.ok) {
                toast.success('Xóa hồ sơ thành công');
                queryClient.invalidateQueries(['myApplications']);
                refetch();
            } else {
                toast.error('Có lỗi xảy ra khi xóa hồ sơ');
            }
        } catch (error) {
            toast.error(error?.message || 'Có lỗi xảy ra khi xóa hồ sơ');
        }
        setOpenConfirmDeleteModal(false);
        setIdWantDelete('');
    };

    const cancelDelete = () => {
        setIdWantDelete('');
        setOpenConfirmDeleteModal(false);
    };

    const getPaymentAmount = (app) => {
        if (activeTab === '0') return app.lePhi ?? app.LePhi;
        if (activeTab === '1') return app.hocPhi ?? app.HocPhi;

        const chucDanhId = app.chucDanhId ?? app.ChucDanhId;
        const chucDanh = listDoiTuong.find(
            (item) => String(item.id ?? item.Id).toLowerCase() === String(chucDanhId).toLowerCase()
        );
        const tenChucDanh = (chucDanh?.tenDoiTuong ?? chucDanh?.TenDoiTuong ?? '')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/đ/g, 'd')
            .replace(/Đ/g, 'D')
            .toLowerCase()
            .trim();

        if (tenChucDanh.includes('bac si')) return app.hocPhiBacSi ?? app.HocPhiBacSi;
        if (tenChucDanh.includes('y si')) return app.hocPhiYSi ?? app.HocPhiYSi;
        if (tenChucDanh.includes('dieu duong')) return app.hocPhiDieuDuong ?? app.HocPhiDieuDuong;
        if (tenChucDanh.includes('ktv') || tenChucDanh.includes('ky thuat vien')) {
            return app.hocPhiKTV ?? app.HocPhiKTV;
        }

        return undefined;
    };

    const handleQRGenerate = async (model) => {
        const response = await Post(QRGENERATOR_API.CREATE, null, model, false, false, true);

        const apiResponse = typeof response?.apiResponse === 'string'
            ? JSON.parse(response.apiResponse)
            : response?.apiResponse;

        if (apiResponse?.status?.statusCode !== '0' || !apiResponse?.data?.base64QRCode) {
            throw new Error(apiResponse?.status?.statusDesc || 'Không tạo được mã QR thanh toán');
        }

        // Đây là nội dung VietQR được mã hóa base64, không phải dữ liệu ảnh.
        return window.atob(apiResponse.data.base64QRCode);
    };

    const generateQRCode = async (model) => {
        if (!model) return;

        setQrCodeValue('');
        setQrSecondsRemaining(0);
        setIsGeneratingQR(true);

        try {
            const qrValue = await handleQRGenerate(model);
            if (currentPaymentCodeRef.current !== model.accountNumber) return;
            setQrCodeValue(qrValue);
            setQrSecondsRemaining(QR_VALIDITY_SECONDS);
        } catch (error) {
            toast.error(error?.message || 'Đã có lỗi khi tạo mã QR, vui lòng thử lại');
        } finally {
            setIsGeneratingQR(false);
        }
    };

    useEffect(() => {
        if (!showQRModal || !qrCodeValue) return undefined;

        const timer = window.setInterval(() => {
            setQrSecondsRemaining((seconds) => {
                if (seconds <= 1) {
                    window.clearInterval(timer);
                    setQrCodeValue('');
                    return 0;
                }
                return seconds - 1;
            });
        }, 1000);

        return () => window.clearInterval(timer);
    }, [showQRModal, qrCodeValue]);

    const handleNextStep = async (app, payment, maGhiChu, dotThanhToan) => {
        const amount = Number(payment?.lePhi ?? payment?.LePhi ?? getPaymentAmount(app));
        if (!Number.isFinite(amount) || amount <= 0) {
            toast.error('Hồ sơ chưa có mức lệ phí/học phí hợp lệ');
            return;
        }

        setSelectedHoSoId(app.id || app.Id);
        setFileMinhChungLePhi(app.fileMinhChungLePhi || app.FileMinhChungLePhi || '');
        setQrAmount(amount);
        setSoHoSo(app.soHoSo || app.SoHoSo || 'Chưa cấp');
        setQrCodeValue('');
        setQrSecondsRemaining(0);
        setShowQRModal(true);

        setGhiChu(maGhiChu);

        const soHoSo = app.soHoSo || app.SoHoSo || '';
        const loaiTuyenSinhChar = soHoSo[2];
        const model = {
            accountNumber: loaiTuyenSinhChar === '1' ? soHoSo : `${soHoSo}${dotThanhToan ?? ''}`,
            amount: amount,
            ghiChu: maGhiChu
        };

        setMaThanhToan(loaiTuyenSinhChar === '1' ? soHoSo : `${soHoSo}${dotThanhToan ?? ''}`);

        currentPaymentCodeRef.current = model.accountNumber;
        currentPaymentInvoiceRef.current = {
            app,
            payment,
            dotThanhToan,
            erpId: model.accountNumber
        };
        setQrRequestModel(model);
        await generateQRCode(model);
    };

    const handleSaveFile = async () => {
        if (!selectedHoSoId) return;
        try {
            const res = await Get(HOSO_TUYENSINH_API.GET_ITEM, selectedHoSoId);
            if (res) {
                let fullItem = res.data ? res.data : res;
                fullItem.fileMinhChungLePhi = fileMinhChungLePhi;
                const updateRes = await Put(HOSO_TUYENSINH_API.UPDATE_ITEM, selectedHoSoId, fullItem);
                if (updateRes && updateRes.ok) {
                    toast.success('Lưu file minh chứng thành công');
                    setShowQRModal(false);
                    queryClient.invalidateQueries(['myApplications']);
                    refetch();
                } else {
                    toast.error('Có lỗi xảy ra khi lưu file');
                }
            } else {
                toast.error('Không lấy được dữ liệu hồ sơ');
            }
        } catch (error) {
            toast.error('Có lỗi xảy ra khi lưu file');
            console.error(error);
        }
    };

    const handleTriggerSubmit = (app) => {
        setAppToSubmit(app);
        setOpenConfirmSubmitModal(true);
    };

    const handleUpdateInvoiceInfo = async (app, payment, dotThanhToan) => {
        const applicationCode = app?.soHoSo ?? app?.SoHoSo ?? '';
        const getDotThanhToan = applicationCode[2] != '1' ? dotThanhToan : '';
        const paymentHistoryResponse = await Get(
            LICHSUTHANHTOAN_API.GET_ITEM_BY_CUSTCODE,
            `${applicationCode}${getDotThanhToan}`
        );
        const paymentHistory = paymentHistoryResponse?.data ?? paymentHistoryResponse;

        if (paymentHistory == null || paymentHistory == undefined) {
            toast.error('Cần thanh toán trước');
        } else {
            const invoices = getInvoicesFromPaymentHistory(paymentHistory);
            const hoaDonThanhToans = invoices.filter(invoice => normalizeInvoiceStatus(
                invoice?.invoiceStatus ?? invoice?.InvoiceStatus
            ) === invoiceStatusValues.YeuCauPhatHanh);

            if (hoaDonThanhToans.length > 0) {
                const invoice = hoaDonThanhToans[0];
                setXuatHoaDonData({
                    app,
                    payment,
                    dotThanhToan,
                    erpId: invoice?.erpid ?? invoice?.ERPID,
                    mode: 'edit'
                });
            } else {
                toast.error('Hóa đơn đã phát hành hoặc nếu chưa thì cần thanh toán trước');
            }
        }
    };

    const confirmSubmitHoSo = async () => {
        if (!appToSubmit) return;
        const id = appToSubmit.id || appToSubmit.Id;
        setOpenConfirmSubmitModal(false);
        try {
            const res = await Get(HOSO_TUYENSINH_API.GET_ITEM, id);
            if (res) {
                let fullItem = res.data ? res.data : res;

                // Validate mandatory fields before submitting
                let isValid = true;
                const loaiTuyenSinh = fullItem.loaiTuyenSinh;

                if (loaiTuyenSinh === loaiTuyenSinhValue.tuyenSinhTienSi) {
                    const reqHoSoFields = ['hoTen', 'ngaySinh', 'email', 'soDienThoai', 'noiSinh', 'hoTenNguoiLienHe', 'quanHeNguoiLienHe', 'sdtNguoiLienHe', 'nganhId', 'fileAnhChanDung', 'fileDonXinDuTuyen', 'fileSoYeuLyLich', 'fileGiayKhamSucKhoe'];
                    for (let f of reqHoSoFields) {
                        const val = fullItem[f];
                        if (val === null || val === undefined || val === '') {
                            isValid = false;
                            break;
                        }
                    }
                    if (isValid && (fullItem.isDoiTuongMienGiam === null || fullItem.isDoiTuongMienGiam === undefined)) {
                        isValid = false;
                    }
                    if (isValid && (fullItem.isDoiTuongMienGiam === true || fullItem.isDoiTuongMienGiam === 'true') && !fullItem.fileMinhChungMienGiam) {
                        isValid = false;
                    }
                    if (isValid && !fullItem.donViId && !fullItem.donViNgoaiVien) {
                        isValid = false;
                    }

                    if (isValid) {
                        const [lyLichRes, deCuongRes, chuyenNganhRes] = await Promise.all([
                            Get(LYLICHKHOAHOC_API.GET_BY_HOSO_ID, null, { hoSoTuyenSinhId: id }),
                            Get(DECUONGNGHIENCUU_API.GET_BY_HOSO_ID, null, { hoSoTuyenSinhId: id }),
                            Get(CHUYENNGANH_API.GET_PAGING_NOT_MENU + '?pageSize=1000')
                        ]);
                        const lyLich = lyLichRes?.data || lyLichRes;
                        const deCuong = deCuongRes?.data || deCuongRes;
                        
                        const chuyenNganhList = chuyenNganhRes?.data?.$values || chuyenNganhRes?.data || [];
                        if (fullItem.nganhId) {
                            const hasChuyenNganh = chuyenNganhList.some(x => x.nganhId === fullItem.nganhId);
                            if (hasChuyenNganh && !fullItem.chuyenNganhId) {
                                isValid = false;
                            }
                        }

                        const fileLyLich = lyLich?.fileLyLichKhoaHoc;
                        const tenDeCuong = deCuong?.tenDeCuong;
                        const fileDeCuong = deCuong?.fileMinhChung;

                        if (!fileLyLich || !tenDeCuong || !fileDeCuong) {
                            isValid = false;
                        }
                    }
                } else {
                    const reqHoSoFields = ['hoTen', 'ngaySinh', 'email', 'soDienThoai', 'noiSinh', 'hoTenNguoiLienHe', 'sdtNguoiLienHe', 'fileAnhChanDung', 'fileAnhCccd', 'fileDonXinDuTuyen', 'fileBangTotNghiep', 'fileSoYeuLyLich'];
                    if (loaiTuyenSinh === loaiTuyenSinhValue.tuyenSinhDTTH) reqHoSoFields.push('chucDanhId');
                    for (let f of reqHoSoFields) {
                        const val = fullItem[f];
                        if (val === null || val === undefined || val === '') {
                            isValid = false;
                            break;
                        }
                    }
                    if (isValid && (fullItem.isDoiTuongMienGiam === null || fullItem.isDoiTuongMienGiam === undefined)) {
                        isValid = false;
                    }
                    if (isValid && (fullItem.isDoiTuongMienGiam === true || fullItem.isDoiTuongMienGiam === 'true') && !fullItem.fileMinhChungMienGiam) {
                        isValid = false;
                    }
                    if (isValid && !fullItem.donViId && !fullItem.donViNgoaiVien) {
                        isValid = false;
                    }

                    if (isValid) {
                        const vanBangRes = await Get(VANBANGDAIHOC_API.GET_BY_HOSO_ID, id);
                        const vanBangList = vanBangRes?.data?.$values || vanBangRes?.data || [];
                        if (vanBangList.length === 0) {
                            isValid = false;
                        }
                    }
                }

                if (!isValid) {
                    toast.warning('Vui lòng điền đầy đủ các thông tin bắt buộc trước khi gửi!');
                    return;
                }

                fullItem.trangThaiHoSoDuTuyen = trangThaiHoSoDuTuyenValue.choDuyet;
                fullItem.TrangThaiHoSoDuTuyen = trangThaiHoSoDuTuyenValue.choDuyet;
                fullItem.ghiChuChinhSua = null;
                fullItem.GhiChuChinhSua = null;

                const updateRes = await Put(HOSO_TUYENSINH_API.UPDATE_ITEM, id, fullItem);
                if (updateRes && updateRes.ok) {
                    toast.success('Gửi hồ sơ thành công');
                    queryClient.invalidateQueries(['myApplications']);
                    refetch();
                } else {
                    toast.error('Có lỗi xảy ra khi gửi hồ sơ');
                }
            } else {
                toast.error('Không lấy được dữ liệu hồ sơ');
            }
        } catch (error) {
            toast.error('Có lỗi xảy ra khi gửi hồ sơ');
            console.error(error);
        }
    };

    return (
        <div className="container-fluid">
            <Tab.Container activeKey={activeTab} onSelect={handleSelectTab} id="tabs-ho-so-tuyen-sinh">
                <Card className="card-sticky-layout card-sticky-layout-lg">
                    <Card.Header>
                        <div className="d-flex justify-content-between align-items-center">
                            <Nav variant="pills" className="flex-row">
                                <Nav.Item>
                                    <Nav.Link eventKey="0" className="font-weight-bold">Tuyển sinh Tiến sĩ</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="1" className="font-weight-bold">Tuyển sinh đào tạo liên tục</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="2" className="font-weight-bold">Tuyển sinh đào tạo thực hành</Nav.Link>
                                </Nav.Item>
                            </Nav>
                        </div>
                    </Card.Header>
                    <Card.Body className="d-flex flex-column p-0">
                        <Card className="card-sticky-layout border-0 shadow-none flex-grow-1">
                            <Card.Body className="d-flex flex-column">
                                <Tab.Content className="d-flex flex-column flex-grow-1">
                                    <Tab.Pane eventKey={activeTab} className="d-flex flex-column flex-grow-1 h-100">
                                        <div className="table-responsive flex-grow-1">
                                    <Table striped bordered hover>
                                        <thead>
                                            <tr>
                                                <th>Số hồ sơ</th>
                                                <th>{activeTab === '0' ? 'Đợt tuyển sinh' : 'Tên khóa học'}</th>
                                                <th>Ngày nộp</th>
                                                <th className="text-center">Trạng thái hồ sơ</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {isLoading ? (
                                                <tr>
                                                    <td colSpan={4}>Đang tải...</td>
                                                </tr>
                                            ) : isError ? (
                                                <tr>
                                                    <td colSpan={4}>Lỗi: {error?.message || 'Không tải được dữ liệu'}</td>
                                                </tr>
                                            ) : items.length === 0 ? (
                                                <tr>
                                                    <td colSpan={4}>Bạn chưa có hồ sơ đăng ký tuyển sinh nào.</td>
                                                </tr>
                                            ) : (
                                                items.map((app, idx) => {
                                                    const statusValue = app.trangThaiHoSoDuTuyen;
                                                    const statusLabel = getLabelFromEnum(statusValue, objectTrangThaiHoSoDuTuyen, trangThaiHoSoDuTuyenValue);
                                                    let cDate = app.ngayNop || app.createdDate;
                                                    const dateStr = cDate ? moment(cDate).format('DD/MM/YYYY HH:mm') : '';

                                                    let noteColor = '#b45309';
                                                    let noteBgColor = '#fffbeb';
                                                    let noteBorderColor = '#f59e0b';
                                                    let iconClass = 'fa-exclamation-circle';

                                                    if (statusLabel === 'Duyệt') {
                                                        noteColor = '#065f46';
                                                        noteBgColor = '#ecfdf5';
                                                        noteBorderColor = '#10b981';
                                                        iconClass = 'fa-check-circle';
                                                    } else if (statusLabel === 'Từ chối') {
                                                        noteColor = '#991b1b';
                                                        noteBgColor = '#fef2f2';
                                                        noteBorderColor = '#ef4444';
                                                        iconClass = 'fa-times-circle';
                                                    }

                                                    return (
                                                        <React.Fragment key={app.id || idx}>
                                                            <tr 
                                                                onClick={() => setSelectedRow(app)}
                                                                className={selectedRow && (selectedRow.id || selectedRow.Id) === (app.id || app.Id) ? 'table-primary' : ''}
                                                                style={{ cursor: 'pointer' }}
                                                            >
                                                                <td className="font-weight-bold text-primary">{app.soHoSo || app.SoHoSo || 'Chưa cấp'}</td>
                                                                <td>{app.tenDotTuyenSinh || app.TenDotTuyenSinh}</td>
                                                                <td>{dateStr}</td>
                                                                <td className="text-center">
                                                                    <BsBadge
                                                                        variant={
                                                                            statusLabel === 'Duyệt' ? 'success' :
                                                                                statusLabel === 'Từ chối' ? 'danger' :
                                                                                    statusLabel === 'Cần chỉnh sửa' ? 'warning' : 'info'
                                                                        }
                                                                        className="px-3 py-2"
                                                                        style={{ borderRadius: '20px' }}
                                                                    >
                                                                        {statusLabel}
                                                                    </BsBadge>
                                                                </td>
                                                            </tr>
                                                            {!!(app.ghiChuChinhSua?.trim() || app.GhiChuChinhSua?.trim()) && (
                                                                <tr>
                                                                    <td colSpan={4} className="p-0 border-0">
                                                                        <div className="mx-3 mb-3 mt-2 p-3 rounded" style={{ borderLeft: `4px solid ${noteBorderColor}`, backgroundColor: noteBgColor }}>
                                                                            <div className="d-flex align-items-start">
                                                                                <i className={`fas ${iconClass} mt-1 mr-2`} style={{ fontSize: '1.2rem', color: noteBorderColor }}></i>
                                                                                <div>
                                                                                    <strong style={{ color: noteColor }}>Phản hồi từ cán bộ duyệt hồ sơ: </strong>
                                                                                    <span style={{ color: noteColor, whiteSpace: 'pre-wrap' }}>{app.ghiChuChinhSua || app.GhiChuChinhSua}</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            )}
                                                            {/* {!(activeTab === '0' && (app.doiTuong === 1 || app.DoiTuong === 1 || String(app.doiTuong).toLowerCase() === 'quan' || String(app.DoiTuong).toLowerCase() === 'quan')) && ( */}
                                                            {[...(app.lstThanhToanLePhi ?? app.LstThanhToanLePhi ?? [])]
                                                                    .sort((a, b) => (a.dotThanhToan ?? a.DotThanhToan ?? 0) - (b.dotThanhToan ?? b.DotThanhToan ?? 0))
                                                                    .map((item, paymentIndex) => {
                                                                        const dotThanhToan = item.dotThanhToan ?? item.DotThanhToan ?? paymentIndex + 1;
                                                                        const ngayBatDau = item.ngayBatDau ?? item.NgayBatDau;
                                                                        const ngayKetThuc = item.ngayKetThuc ?? item.NgayKetThuc;
                                                                        const thoiGianThanhToan = ngayBatDau || ngayKetThuc
                                                                            ? `${ngayBatDau ? moment(ngayBatDau).format('DD/MM/YYYY') : 'Không giới hạn'} - ${ngayKetThuc ? moment(ngayKetThuc).format('DD/MM/YYYY') : 'Không giới hạn'}`
                                                                            : 'Không giới hạn thời gian';
                                                                        const maGhiChu = item.maLop + item.dotThanhToan;
                                                                        const currentDate = moment();
                                                                        const isTrongDotThanhToan = (ngayBatDau ? currentDate.isSameOrAfter(moment(ngayBatDau).startOf('day')) : true) && (ngayKetThuc ? currentDate.isSameOrBefore(moment(ngayKetThuc).endOf('day')) : true);
                                                                        // if (!isTrongDotThanhToan && !item.isActive) return <></>;

                                                                        return (
                                                                            <tr key={item.id ?? item.Id ?? `${app.id ?? app.Id}-payment-${dotThanhToan}`}>
                                                                                <td colSpan={4} className="p-0 border-0" style={{ backgroundColor: '#f8fafc' }}>
                                                                                    <div className="mx-3 my-3 p-4 d-flex justify-content-between align-items-center position-relative overflow-hidden" style={{ backgroundColor: '#ffffff', borderRadius: '16px', border: '1px solid #e5e7eb', boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.05), 0 8px 10px -6px rgba(0, 0, 0, 0.01)' }}>
                                                                                        {/* Background decoration */}
                                                                                        <div className="position-absolute" style={{ top: '-50px', right: '-20px', width: '200px', height: '200px', background: 'radial-gradient(circle, rgba(16,185,129,0.08) 0%, rgba(255,255,255,0) 70%)', borderRadius: '50%' }}></div>
                                                                                        <div className="position-absolute" style={{ left: 0, top: 0, bottom: 0, width: '6px', background: 'linear-gradient(to bottom, #34d399, #059669)' }}></div>

                                                                                        <div className="d-flex align-items-center" style={{ paddingLeft: '12px', zIndex: 1 }}>
                                                                                            <div className="rounded-circle d-flex align-items-center justify-content-center mr-4 shadow-sm" style={{ width: '56px', minWidth: '56px', height: '56px', background: '#ecfdf5', color: '#059669', fontSize: '1.6rem', border: '1px solid #a7f3d0' }}>
                                                                                                <i className="fas fa-wallet"></i>
                                                                                            </div>
                                                                                            <div>
                                                                                                <div className="d-flex align-items-center mb-1">
                                                                                                    <h5 className="mb-0 font-weight-bold" style={{ color: '#111827', fontSize: '1.2rem', letterSpacing: '-0.3px' }}>Bước 2: Hoàn tất lệ phí xét tuyển đợt {dotThanhToan}</h5>
                                                                                                </div>
                                                                                                <span style={{ color: '#4b5563', fontSize: '0.95rem' }}>Hồ sơ của bạn đã được ghi nhận. Vui lòng thanh toán lệ phí qua mã QR và tải minh chứng để hoàn thành.</span>
                                                                                                <div className="mt-2 d-flex align-items-center" style={{ color: '#6b7280', fontSize: '0.9rem' }}>
                                                                                                    <i className="far fa-calendar-alt mr-2" style={{ color: '#059669' }}></i>
                                                                                                    <span><strong>Thời gian thanh toán:</strong> {thoiGianThanhToan}</span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        {(app.isDoiTuongMienGiam === false || app.IsDoiTuongMienGiam === false) && (isTrongDotThanhToan || item.isActive) && (
                                                                                            <div className="ml-4 d-flex flex-column align-items-stretch" style={{ zIndex: 1 }}>
                                                                                                <Button onClick={() => handleNextStep(app, item, maGhiChu, dotThanhToan)} className="px-4 py-2 d-flex align-items-center justify-content-center border-0 shadow-sm" style={{ backgroundColor: '#10b981', borderRadius: '8px', color: '#ffffff', transition: 'all 0.2s ease', fontSize: '1rem', fontWeight: '500' }} onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#059669'; e.currentTarget.style.transform = 'translateY(-1px)'; }} onMouseOut={(e) => { e.currentTarget.style.backgroundColor = '#10b981'; e.currentTarget.style.transform = 'translateY(0)'; }}>
                                                                                                    <i className="fas fa-qrcode mr-2" style={{ fontSize: '1.1rem' }}></i> Thanh toán
                                                                                                </Button>
                                                                                                {canShowInvoiceActions && (
                                                                                                    <>
                                                                                                        <Button onClick={() => handleUpdateInvoiceInfo(app, item, dotThanhToan)} className="mt-2 px-4 py-2 d-flex align-items-center justify-content-center border-0 shadow-sm" style={{ backgroundColor: '#10b981', borderRadius: '8px', color: '#ffffff', transition: 'all 0.2s ease', fontSize: '1rem', fontWeight: '500' }} onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#059669'; e.currentTarget.style.transform = 'translateY(-1px)'; }} onMouseOut={(e) => { e.currentTarget.style.backgroundColor = '#10b981'; e.currentTarget.style.transform = 'translateY(0)'; }}>
                                                                                                            <i className="fas fa-file-invoice mr-2" style={{ fontSize: '1.1rem' }}></i> Cập nhật thông tin xuất hóa đơn
                                                                                                        </Button>
                                                                                                        <InvoicePreviewButton
                                                                                                            applicationCode={app?.soHoSo ?? app?.SoHoSo ?? ''}
                                                                                                            dotThanhToan={dotThanhToan}
                                                                                                        />
                                                                                                        {/* <Button onClick={() => setXuatHoaDonData({ app, payment: item, dotThanhToan, mode: 'replace' })} className="mt-2 px-4 py-2 d-flex align-items-center justify-content-center border-0 shadow-sm" style={{ backgroundColor: '#10b981', borderRadius: '8px', color: '#ffffff', transition: 'all 0.2s ease', fontSize: '1rem', fontWeight: '500' }} onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#059669'; e.currentTarget.style.transform = 'translateY(-1px)'; }} onMouseOut={(e) => { e.currentTarget.style.backgroundColor = '#10b981'; e.currentTarget.style.transform = 'translateY(0)'; }}>
                                                                                                            <i className="fas fa-file-invoice mr-2" style={{ fontSize: '1.1rem' }}></i> Thay thế hóa đơn
                                                                                                        </Button> */}
                                                                                                        <Button onClick={() => setXuatHoaDonData({ app, payment: item, dotThanhToan, mode: 'adjust' })} className="mt-2 px-4 py-2 d-flex align-items-center justify-content-center border-0 shadow-sm" style={{ backgroundColor: '#10b981', borderRadius: '8px', color: '#ffffff', transition: 'all 0.2s ease', fontSize: '1rem', fontWeight: '500' }} onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#059669'; e.currentTarget.style.transform = 'translateY(-1px)'; }} onMouseOut={(e) => { e.currentTarget.style.backgroundColor = '#10b981'; e.currentTarget.style.transform = 'translateY(0)'; }}>
                                                                                                            <i className="fas fa-file-invoice mr-2" style={{ fontSize: '1.1rem' }}></i> Yêu cầu hoàn tiền
                                                                                                        </Button>
                                                                                                    </>
                                                                                                )}
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        );
                                                                    })}
                                                        </React.Fragment>
                                                    );
                                                })
                                            )}
                                        </tbody>
                                    </Table>
                                </div>

                                {/* 
                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                            <Form.Control as="select" value={pageSize} onChange={onChangeShowNumber} style={{ width: '100px' }}>
                                {objectShowNumber.map((opt) => (
                                    <option key={opt.value} value={opt.value}>{opt.text}</option>
                                ))}
                            </Form.Control>
                        </div>
                        <div>
                            <Pagination
                                itemClass="page-item"
                                linkClass="page-link"
                                innerClass="pagination pagination-sm no-margin"
                                activePage={page}
                                itemsCountPerPage={pageSize}
                                totalItemsCount={totalRecords}
                                pageRangeDisplayed={5}
                                onChange={changePage}
                            />
                        </div>
                    </div>
                    */}
                            </Tab.Pane>
                        </Tab.Content>
                    </Card.Body>
                    {!isLoading && (
                        <Card.Footer className="bg-white card-footer-sticky">
                            <div className="d-flex justify-content-end pr-4">
                                <Button
                                    variant="info"
                                    size="sm"
                                    className="mr-2"
                                    disabled={!selectedRow}
                                    onClick={() => handleViewDetail(selectedRow)}>
                                    <i className="fas fa-eye mr-1"></i> Xem chi tiết
                                </Button>
                                <Button
                                    variant="warning"
                                    size="sm"
                                    className="mr-2 text-white"
                                    disabled={!selectedRow || !(getLabelFromEnum(selectedRow?.trangThaiHoSoDuTuyen ?? selectedRow?.TrangThaiHoSoDuTuyen, objectTrangThaiHoSoDuTuyen, trangThaiHoSoDuTuyenValue) === 'Chờ gửi' || getLabelFromEnum(selectedRow?.trangThaiHoSoDuTuyen ?? selectedRow?.TrangThaiHoSoDuTuyen, objectTrangThaiHoSoDuTuyen, trangThaiHoSoDuTuyenValue) === 'Cần chỉnh sửa')}
                                    onClick={() => handleEdit(selectedRow)}>
                                    <i className="fas fa-edit mr-1"></i> Sửa
                                </Button>
                                <Button
                                    variant="danger"
                                    size="sm"
                                    className="mr-2"
                                    disabled={!selectedRow || !(getLabelFromEnum(selectedRow?.trangThaiHoSoDuTuyen ?? selectedRow?.TrangThaiHoSoDuTuyen, objectTrangThaiHoSoDuTuyen, trangThaiHoSoDuTuyenValue) === 'Chờ gửi' || getLabelFromEnum(selectedRow?.trangThaiHoSoDuTuyen ?? selectedRow?.TrangThaiHoSoDuTuyen, objectTrangThaiHoSoDuTuyen, trangThaiHoSoDuTuyenValue) === 'Cần chỉnh sửa')}
                                    onClick={() => handleDelete(selectedRow)}>
                                    <i className="fas fa-trash mr-1"></i> Xóa
                                </Button>
                                <Button
                                    variant="primary"
                                    size="sm"
                                    disabled={!selectedRow || !(getLabelFromEnum(selectedRow?.trangThaiHoSoDuTuyen ?? selectedRow?.TrangThaiHoSoDuTuyen, objectTrangThaiHoSoDuTuyen, trangThaiHoSoDuTuyenValue) === 'Chờ gửi' || getLabelFromEnum(selectedRow?.trangThaiHoSoDuTuyen ?? selectedRow?.TrangThaiHoSoDuTuyen, objectTrangThaiHoSoDuTuyen, trangThaiHoSoDuTuyenValue) === 'Cần chỉnh sửa')}
                                    onClick={() => handleTriggerSubmit(selectedRow)}>
                                    <i className="fas fa-paper-plane mr-1"></i> Gửi đi
                                </Button>
                            </div>
                        </Card.Footer>
                    )}
                        </Card>
                    </Card.Body>
                </Card>
            </Tab.Container>

            {showDetail && (
                <HoSoTuyenSinhDetailModal
                    show={showDetail}
                    handleClose={() => {
                        setShowDetail(false);
                        setSelectedHoSoId(null);
                    }}
                    hoSoId={selectedHoSoId}
                />
            )}

            {showEdit && activeTab === '0' && (
                <DangKyHoSoModal
                    show={showEdit}
                    handleClose={() => {
                        setShowEdit(false);
                        setSelectedHoSoId(null);
                        setSelectedDotTuyenSinhId(null);
                        queryClient.invalidateQueries(['myApplications']);
                        refetch();
                    }}
                    hoSoId={selectedHoSoId}
                    dotTuyenSinhId={selectedDotTuyenSinhId}
                />
            )}

            {showEdit && (activeTab === '1' || activeTab === '2') && (
                <DangKyHoSoLopDaoTaoModal
                    show={showEdit}
                    handleClose={() => {
                        setShowEdit(false);
                        setSelectedHoSoId(null);
                        setSelectedDotTuyenSinhId(null);
                        queryClient.invalidateQueries(['myApplications']);
                        refetch();
                    }}
                    hoSoId={selectedHoSoId}
                    dotTuyenSinhId={selectedDotTuyenSinhId}
                    loaiTuyenSinh={Number(activeTab)}
                />
            )}

            <ConfirmModal
                isOpen={openConfirmDeleteModal}
                confirmType="delete"
                handleAccept={acceptDelete}
                handleCancel={cancelDelete}
                content={confirmDelMessage}
                goBackAfterDelete={false}
            />

            <ConfirmModal
                isOpen={openConfirmSubmitModal}
                handleAccept={confirmSubmitHoSo}
                handleCancel={() => setOpenConfirmSubmitModal(false)}
                content="Bạn có chắc chắn muốn gửi hồ sơ này đi để xét duyệt không?"
                labelAccept="Gửi đi"
            />

            <Modal
                show={!!paymentError}
                onHide={() => setPaymentError('')}
                centered
                backdrop="static"
                aria-labelledby="payment-error-title"
                aria-describedby="payment-error-message"
                contentClassName="border-0 rounded-lg shadow-lg"
                style={{ zIndex: 10000 }}
            >
                <Modal.Body className="p-4 text-center" style={{ background: '#fff5f5', borderRadius: '8px', borderTop: '5px solid #dc2626' }}>
                    <div className="d-inline-flex align-items-center justify-content-center mb-3" style={{ width: 64, height: 64, borderRadius: '50%', background: '#fee2e2', color: '#dc2626' }}>
                        <i className="fas fa-exclamation-triangle" style={{ fontSize: 28 }} aria-hidden="true" />
                    </div>
                    <h4 id="payment-error-title" style={{ color: '#b91c1c', fontWeight: 700 }}>Không thể ghi nhận thanh toán</h4>
                    <p id="payment-error-message" role="alert" className="mt-3 mb-4" style={{ color: '#b91c1c', lineHeight: 1.7, whiteSpace: 'pre-line', overflowWrap: 'anywhere' }}>{paymentError}</p>
                    <Button variant="danger" className="px-4 py-2 rounded-pill" onClick={() => setPaymentError('')}>Đã hiểu</Button>
                </Modal.Body>
            </Modal>

            <XuatHoaDonModal
                show={!!xuatHoaDonData && !paymentError}
                onHide={() => setXuatHoaDonData(null)}
                onSuccess={() => {
                    queryClient.invalidateQueries(['myApplications']);
                    refetch();
                }}
                app={xuatHoaDonData?.app}
                payment={xuatHoaDonData?.payment}
                dotThanhToan={xuatHoaDonData?.dotThanhToan}
                erpId={xuatHoaDonData?.erpId}
                mode={xuatHoaDonData?.mode || 'edit'}
                notification={xuatHoaDonData?.notification}
            />

            <Modal show={showQRModal} onHide={() => setShowQRModal(false)} centered contentClassName="bg-white" style={{ zIndex: 9999 }}>
                <Modal.Header closeButton className="bg-primary text-white border-bottom-0">
                    <Modal.Title><i className="fas fa-qrcode mr-2"></i> Quét mã để chuyển tiền</Modal.Title>
                </Modal.Header>
                <Modal.Body className="bg-white p-3">
                    <div className="text-center mb-3">
                        <div className="bg-white p-2 rounded shadow-sm d-inline-block border" style={{ width: '100%', maxWidth: '380px' }}>
                            <div>
                                <div
                                    style={{
                                        background: '#fff',
                                        padding: 16,
                                        display: 'inline-block',
                                        borderRadius: 8
                                    }}
                                >
                                    {isGeneratingQR ? (
                                        <div className="py-5 px-4 text-muted">
                                            <i className="fas fa-spinner fa-spin mr-2"></i>
                                            Đang tạo mã QR...
                                        </div>
                                    ) : qrCodeValue ? (
                                        <>
                                            <QRCodeSVG
                                                value={qrCodeValue}
                                                size={220}
                                                level="M"
                                                marginSize={4}
                                            />
                                            <div className="mt-2 text-muted">
                                                Mã QR hết hạn sau{' '}
                                                <strong>
                                                    {String(Math.floor(qrSecondsRemaining / 60)).padStart(2, '0')}:
                                                    {String(qrSecondsRemaining % 60).padStart(2, '0')}
                                                </strong>
                                            </div>
                                        </>
                                    ) : (
                                        <div className="py-5 px-4">
                                            <div className="text-danger mb-3">Mã QR đã hết hạn hoặc không tạo được</div>
                                            <Button
                                                variant="primary"
                                                onClick={() => generateQRCode(qrRequestModel)}
                                                disabled={!qrRequestModel}
                                            >
                                                <i className="fas fa-sync-alt mr-2"></i>
                                                Tải lại mã QR
                                            </Button>
                                        </div>
                                    )}
                                </div>

                                <div className="mt-3">
                                    <div><strong>Mã thanh toán:</strong>{' '}{maThanhToan}</div>
                                    <div><strong>Số hồ sơ:</strong>{' '}{soHoSo}</div>
                                    <div><strong>Số tiền:</strong>{' '}{qrAmount.toLocaleString('vi-VN')} VNĐ</div>
                                    <div><strong>Ghi chú:</strong>{' '}{ghiChu}</div>
                                    <div className="text-muted mt-1">Dùng ứng dụng ngân hàng để quét mã VietQR</div>
                                    <div className="text-danger font-weight-bold mt-2">
                                        Tiếp tục bấm vào mục "Cập nhật thông tin" để xuất hóa đơn về đơn vị
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-4 border-top pt-3">
                        <DocumentInput
                            title="File minh chứng lệ phí"
                            labelTitle="Tải lên file minh chứng lệ phí"
                            name="fileMinhChungLePhi"
                            value={fileMinhChungLePhi}
                            onChangeProp={(val) => setFileMinhChungLePhi(val)}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer className="bg-white border-top-0 justify-content-center">
                    <Button variant="outline-secondary" onClick={() => setShowQRModal(false)} className="px-4">
                        Đóng
                    </Button>
                    <Button variant="primary" onClick={handleSaveFile} className="px-4">
                        <i className="fas fa-save mr-2"></i> Lưu file
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default HoSoTuyenSinh;
